import React from 'react';
import { Routes, Route } from 'react-router-dom';
import KeywordsDisplay from './KeywordsDisplay';
import KeywordPage from './KeywordPage';
import './App.css'; // Assuming your CSS from react_keywords_app_css is here or in index.css

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Route for the main page listing all keywords */}
        <Route path="/" element={<KeywordsDisplay />} />

        {/* Dynamic route for individual keyword pages */}
        {/* :keywordId is a URL parameter that will hold the keyword's id */}
        <Route path="/kebab/:keywordId" element={<KeywordPage />} />

        {/* Catch-all route: If no other route matches, display the main KeywordsDisplay page.
            This fulfills the requirement "App should serve content even for non existing pages." */}
        <Route path="*" element={<KeywordsDisplay />} />
      </Routes>
    </div>
  );
}

export default App;
